export default "__VITE_ASSET__068c646d__"